"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

require('./chunk-NESC3UD7.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

var _jsxruntime = require('react/jsx-runtime');

var M = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "InstagramIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M15.0025 9.35948C11.881 9.35948 9.36319 11.8778 9.36319 15C9.36319 18.1222 11.881 20.6405 15.0025 20.6405C18.1239 20.6405 20.6417 18.1222 20.6417 15C20.6417 11.8778 18.1239 9.35948 15.0025 9.35948ZM15.0025 18.6671C12.9853 18.6671 11.3362 17.0225 11.3362 15C11.3362 12.9775 12.9804 11.3329 15.0025 11.3329C17.0245 11.3329 18.6687 12.9775 18.6687 15C18.6687 17.0225 17.0196 18.6671 15.0025 18.6671ZM22.1877 9.12875C22.1877 9.8602 21.5988 10.4444 20.8724 10.4444C20.1411 10.4444 19.5571 9.85529 19.5571 9.12875C19.5571 8.40221 20.146 7.81312 20.8724 7.81312C21.5988 7.81312 22.1877 8.40221 22.1877 9.12875ZM25.9227 10.464C25.8393 8.70166 25.4368 7.14058 24.146 5.8544C22.8601 4.56822 21.2994 4.16568 19.5374 4.07732C17.7215 3.97423 12.2785 3.97423 10.4626 4.07732C8.70552 4.16077 7.14479 4.56332 5.85399 5.84949C4.56319 7.13567 4.16564 8.69675 4.0773 10.4591C3.97423 12.2755 3.97423 17.7196 4.0773 19.536C4.16074 21.2983 4.56319 22.8594 5.85399 24.1456C7.14479 25.4318 8.70061 25.8343 10.4626 25.9227C12.2785 26.0258 17.7215 26.0258 19.5374 25.9227C21.2994 25.8392 22.8601 25.4367 24.146 24.1456C25.4319 22.8594 25.8344 21.2983 25.9227 19.536C26.0258 17.7196 26.0258 12.2804 25.9227 10.464ZM23.5767 21.4849C23.1939 22.4471 22.4528 23.1883 21.4859 23.5761C20.038 24.1505 16.6025 24.018 15.0025 24.018C13.4025 24.018 9.96196 24.1456 8.51902 23.5761C7.55705 23.1932 6.81595 22.452 6.42822 21.4849C5.85399 20.0367 5.9865 16.6004 5.9865 15C5.9865 13.3996 5.8589 9.95838 6.42822 8.51512C6.81104 7.55294 7.55215 6.81167 8.51902 6.42385C9.96687 5.84949 13.4025 5.98204 15.0025 5.98204C16.6025 5.98204 20.0429 5.8544 21.4859 6.42385C22.4479 6.80676 23.189 7.54803 23.5767 8.51512C24.1509 9.96329 24.0184 13.3996 24.0184 15C24.0184 16.6004 24.1509 20.0416 23.5767 21.4849Z"
  }),
  svgElements: ["path"]
});

exports.InstagramIconMedium = M;